export default __webpack_public_path__ + "static/media/trade.e503ab97.PNG";